class SCSMenu01 {
    static TEST_NAME = 'SCS_menu_01';
    static DRAWER_DETAILS_SELECTOR = '#Details-menu-drawer-container';
    static DRAWER_SELECTOR = '#Details-menu-drawer-container #menu-drawer';
    static NAV_SELECTOR = '#Details-menu-drawer-container #menu-drawer .menu-drawer__navigation';
    static HEADER_GROUP_SELECTOR = '.shopify-section-group-header-group';
    static LOGO_URL = 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/scs-menu-01-logo.svg?v=1781098669';
    static FONT_URL = 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&display=swap';
    static CLOSE_ICON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M23 23L1 1M23 1L1 23" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>';
    static MENU_DATA = [
        {
            name: 'Home',
            link: '/',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/scs-menu-01-home.png?v=1781098669',
            isHome: true
        },
        {
            name: 'Seat Covers',
            link: '/products/luxury-seat-covers',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/scs-menu-01-seat-cover.png?v=1781098670'
        },
        {
            name: 'Steering Wheel Covers',
            link: '/products/steering-wheel-cover',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/scs-menu-01-wheel-cover.png?v=1781098669'
        },
        {
            name: 'Pet Seat Covers',
            link: 'https://www.seatcoversolutions.com/products/petsuite-hard-bottom-dog-seat-protector-no-fur',
            image: 'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/scs-menu-01-pet-cover.png?v=1781098669'
        },
        {
            name: 'FAQ',
            link: '/pages/frequently-asked-questions'
        },
        {
            name: 'Our Story',
            link: 'https://www.seatcoversolutions.com/pages/our-story'
        }
    ];

    constructor() {
        this.tn = SCSMenu01.TEST_NAME;
    }

    static runAt(selector, callback) {
        const tryFind = () => {
            const el = document.querySelector(selector);
            if (el) {
                callback(el);
                return true;
            }
            return false;
        };

        if (tryFind()) return;

        const observer = new MutationObserver(() => {
            if (tryFind()) observer.disconnect();
        });

        observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    injectFont() {
        if (document.querySelector(`link[data-scs-menu-01-font]`)) return;

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SCSMenu01.FONT_URL;
        link.setAttribute('data-scs-menu-01-font', 'true');
        document.head.appendChild(link);
    }

    buildImageItemsHTML() {
        return SCSMenu01.MENU_DATA
            .filter((item) => item.image)
            .map((item, index) => `
                <div class="${this.tn}__item ${this.tn}__item--image${index === 0 ? ` ${this.tn}__item--first` : ''}">
                    <a href="${item.link}" class="${this.tn}__item-link">
                        <span class="${this.tn}__item-text${item.isHome ? ` ${this.tn}__item-text--home` : ''}">${item.name}</span>
                        <img class="${this.tn}__item-image" src="${item.image}" alt="${item.name}" />
                    </a>
                </div>
            `)
            .join('');
    }

    buildTextItemsHTML() {
        const textItems = SCSMenu01.MENU_DATA.filter((item) => !item.image);
        const [faq, ourStory] = textItems;

        return `
            <div class="${this.tn}__info-section">
                <div class="${this.tn}__info-block">
                    <div class="${this.tn}__divider"></div>
                    <a href="${faq.link}" class="${this.tn}__text-link">${faq.name}</a>
                    <div class="${this.tn}__divider"></div>
                </div>
                <div class="${this.tn}__info-block ${this.tn}__info-block--story">
                    <a href="${ourStory.link}" class="${this.tn}__text-link">${ourStory.name}</a>
                </div>
            </div>
        `;
    }

    buildMenuHTML() {
        return `
            <div id="SCS_menu_01" class="${this.tn}__menu">
                ${this.buildImageItemsHTML()}
                ${this.buildTextItemsHTML()}
            </div>
        `;
    }

    transformHeader(drawer) {
        const header = drawer.querySelector('.menu-drawer__title-and-close-btn');
        if (!header || header.dataset.scsMenu01Header) return;

        const title = header.querySelector('.menu-drawer__title');
        if (title) title.style.display = 'none';

        let logo = header.querySelector(`.${this.tn}__logo`);
        if (!logo) {
            const logoLink = document.createElement('a');
            logoLink.href = '/';
            logoLink.className = `${this.tn}__logo-link`;
            logoLink.setAttribute('aria-label', 'Seat Cover Solutions home');

            logo = document.createElement('img');
            logo.className = `${this.tn}__logo`;
            logo.src = SCSMenu01.LOGO_URL;
            logo.alt = 'Seat Cover Solutions';

            logoLink.appendChild(logo);
            header.insertBefore(logoLink, header.firstChild);
        } else if (logo.tagName === 'IMG' && !logo.closest(`.${this.tn}__logo-link`)) {
            const logoLink = document.createElement('a');
            logoLink.href = '/';
            logoLink.className = `${this.tn}__logo-link`;
            logoLink.setAttribute('aria-label', 'Seat Cover Solutions home');
            logo.parentNode.insertBefore(logoLink, logo);
            logoLink.appendChild(logo);
        }

        const closeBtn = header.querySelector('.menu-drawer__close-menu-btn');
        if (closeBtn) {
            closeBtn.innerHTML = SCSMenu01.CLOSE_ICON_SVG;
        }

        header.dataset.scsMenu01Header = 'true';
    }

    hideLegacyContent(drawer) {
        drawer.querySelectorAll(
            '.menu-drawer__menu, .ACC_SCS_Menu_02_menuBlocks_wrap, .menu-drawer__utility-links'
        ).forEach((el) => {
            el.style.display = 'none';
        });
    }

    injectMenu(nav) {
        if (nav.querySelector('#SCS_menu_01')) return;
        nav.insertAdjacentHTML('beforeend', this.buildMenuHTML());
    }

    bindHeaderZIndexToggle() {
        SCSMenu01.runAt(SCSMenu01.DRAWER_DETAILS_SELECTOR, (details) => {
            const headerGroups = document.querySelectorAll(SCSMenu01.HEADER_GROUP_SELECTOR);

            headerGroups.forEach((el) => {
                if (!el.dataset.scsMenu01OriginalZIndex) {
                    el.dataset.scsMenu01OriginalZIndex = el.style.zIndex;
                }
            });

            const updateHeaderZIndex = () => {
                const isOpen = details.hasAttribute('open');

                headerGroups.forEach((el) => {
                    if (isOpen) {
                        el.style.zIndex = '0';
                        return;
                    }

                    const original = el.dataset.scsMenu01OriginalZIndex;
                    if (original) {
                        el.style.zIndex = original;
                    } else {
                        el.style.removeProperty('z-index');
                    }
                });
            };

            details.addEventListener('toggle', updateHeaderZIndex);
            updateHeaderZIndex();
        });
    }

    init() {
        document.body.classList.add(this.tn);
        this.injectFont();
        this.bindHeaderZIndexToggle();

        SCSMenu01.runAt(SCSMenu01.DRAWER_SELECTOR, (drawer) => {
            this.transformHeader(drawer);
            this.hideLegacyContent(drawer);

            SCSMenu01.runAt(SCSMenu01.NAV_SELECTOR, (nav) => {
                this.injectMenu(nav);
            });
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SCSMenu01().init());
} else {
    new SCSMenu01().init();
}
